var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.sections.contentItems.length > 0
    ? _c(
        "div",
        { staticClass: "row" },
        [
          _vm._l(_vm.sortedContentItems, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "card border-0 mb-3",
                class: _vm.getColumnClass(item.size)
              },
              [
                _c("div", { staticClass: "row p-0 mt-3" }, [
                  _c("div", { staticClass: "col-12 d-flex  " }, [
                    _vm.CustomStepTree[item.type].isCart
                      ? _c("div", { staticClass: "col-sm-2 pl-0" }, [
                          _c("span", {
                            staticClass: "png-icon mb-1 cursor-pointer",
                            class: _vm.OrderSampleEnabled
                              ? "png-icon-icons-glyph--g-my-basket pointer-none"
                              : "png-icon-icons-glyph--k-my-basket",
                            on: {
                              click: function($event) {
                                !_vm.OrderSampleEnabled
                                  ? _vm.addItemToCart(item)
                                  : ""
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.userRole
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-sm-10 d-flex justify-content-end ml-auto pr-0"
                          },
                          [
                            _c("div", { staticClass: "custom-control" }, [
                              _c("input", {
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "checkbox",
                                  id: "board-card" + index
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.projectSelected(item.id)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("label", {
                                staticClass: "custom-control-label",
                                attrs: { for: "board-card" + index }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "btn-group" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "btn-group dropleft",
                                  attrs: { role: "group" }
                                },
                                [
                                  _vm._m(0, true),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "dropdown-menu bg-white",
                                      attrs: {
                                        "aria-labelledby": "dropdownMenuLink"
                                      }
                                    },
                                    [
                                      _vm.showHideEdit &&
                                      (item.type == 0 || item.type == 9)
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "dropdown-item font-16",
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.editColorImg(item)
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    item.type == 0
                                                      ? _vm.$resourceString[
                                                          "myProject.Project.EditPage.Item.EditColorImage"
                                                        ]
                                                      : item.type == 9
                                                      ? _vm.$resourceString[
                                                          "myProject.Project.EditPage.Item.EditTrayDesign"
                                                        ]
                                                      : ""
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.showHideEdit
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "dropdown-item font-16",
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.editContent(item)
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$resourceString[
                                                      "myProject.Project.EditPage.Item.EditSizeAndDesc"
                                                    ]
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.type == 9 &&
                                      _vm.showDuplicateTrayButton(item) &&
                                      _vm.showHideEdit
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "dropdown-item font-16",
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.duplicateTray(item)
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$resourceString[
                                                      "myProject.Project.EditPage.Item.DuplicateTray"
                                                    ]
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.showHideEdit
                                        ? _c("div", {
                                            staticClass: "dropdown-divider"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "dropdown-item font-danger font-16",
                                          class: { disabled: _vm.isDisabled },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.handleDeleteProject(
                                                item
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$resourceString[
                                                  "myProject.Project.EditPage.Item.Delete"
                                                ]
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c("div", { staticClass: "image-grid-wrapp-mt-tray" }, [
                          item.type == 3
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "align-items-center d-flex img-fluid justify-content-center mx-auto small-image-grid document-list"
                                },
                                [
                                  item.coverPhoto
                                    ? _c("img", {
                                        class: _vm.isSVGEncodedDataURL(
                                          item.coverPhoto
                                        )
                                          ? "show-icon h-50"
                                          : "show-image h-100 w-100",
                                        attrs: {
                                          src: item.coverPhoto,
                                          alt: "img"
                                        }
                                      })
                                    : _vm._e()
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "d-block image-grid-my-tray-large img-fluid mx-auto ",
                                  class:
                                    item.size == 2
                                      ? "large-image-grid"
                                      : "small-image-grid"
                                },
                                [
                                  _c(
                                    "picture",
                                    {
                                      staticClass:
                                        "w-100 img-comp wrapperClasses img-comp--glow-animation"
                                    },
                                    [
                                      item.coverPhoto
                                        ? _c("img", {
                                            staticClass: "w-100 item-cover-img",
                                            attrs: {
                                              src: item.coverPhoto,
                                              alt:
                                                item.coverPhotoImageAltText ||
                                                ""
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              ),
                          _vm._v(" "),
                          item.itemBoardId && item.type == 9
                            ? _c(
                                "div",
                                { staticClass: "on-hover-background-card" },
                                [
                                  _c(
                                    "a",
                                    {
                                      ref: "goToEditTray",
                                      refInFor: true,
                                      staticClass:
                                        "btn btn-outline-white-warn btn btn-outline-primary",
                                      attrs: {
                                        href:
                                          "/VirtualTray/EditTray/" +
                                          item.itemBoardId,
                                        rel: "noopener"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$resourceString[
                                            "virtualtray.GoToTray.Msg"
                                          ]
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.type == 10
                            ? _c(
                                "div",
                                { staticClass: "on-hover-background-card" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-outline-white-warn btn btn-outline-primary",
                                      attrs: { rel: "noopener" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          $event.stopPropagation()
                                          return _vm.onImgClick(item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$resourceString[
                                            "common.Label.View"
                                          ]
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.type == 8
                            ? _c(
                                "div",
                                { staticClass: "on-hover-background-card" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-outline-white-warn btn btn-outline-primary",
                                      attrs: {
                                        href: item.link,
                                        rel: "noopener",
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$resourceString[
                                              "myProject.Label.GotoPage"
                                            ]
                                          ) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "bottom-icon",
                            class: item.size != 0 ? "bottom-icon-large" : ""
                          },
                          [
                            item.productContentItem
                              ? _c("my-project-colors-preview-icon", {
                                  attrs: { colors: item },
                                  on: {
                                    colorPreview: function($event) {
                                      return _vm.showColorPreview($event)
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 text-uppercase line-space" },
                    [
                      item.productContentItem
                        ? _c("div", [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "card-title product-list-title my-2",
                                attrs: {
                                  target: "_blank",
                                  href: _vm.$helpers.getProductDetailUrl(
                                    item.link,
                                    item.productContentItem.productId
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      item.title +
                                        " - " +
                                        item.productContentItem.productId
                                    ) +
                                    " "
                                )
                              ]
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "specification-link",
                                attrs: {
                                  href: _vm.getPdmsUrl(
                                    item.productContentItem.productId
                                  ),
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      item.title +
                                        " " +
                                        item.productContentItem.productId
                                    ) +
                                    "\n            " +
                                    _vm._s(
                                      _vm.$resourceString[
                                        "myProject.Project.EditPage.Item.SpecificationLink"
                                      ]
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      item.type == 9
                        ? _c("div", [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "card-title product-list-title black my-2",
                                attrs: {
                                  target: "_blank",
                                  href:
                                    "/VirtualTray/EditTray/" + item.itemBoardId
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(item.title) +
                                    "\n          "
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      item.type == 10
                        ? _c("div", [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "card-title product-list-title black my-2"
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(item.title) +
                                    "\n          "
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      item.type == 3 || item.type == 8
                        ? _c("div", [
                            item.link == "True"
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "card-title product-list-title black my-2",
                                    attrs: {
                                      href:
                                        "/Product/ConstructionSpec/" +
                                        _vm.getLink(item.title)
                                    }
                                  },
                                  [_vm._v(_vm._s(item.title))]
                                )
                              : _c(
                                  "a",
                                  {
                                    staticClass:
                                      "card-title product-list-title black my-2",
                                    attrs: { target: "_blank", href: item.link }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(item.title) +
                                        "\n          "
                                    )
                                  ]
                                )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "card-title item-description black my-2"
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(item.description) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(1, true)
                    ]
                  )
                ])
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: {
                height: "530",
                name: "colors-preview-modal",
                "data-html2canvas-ignore": "true",
                adaptive: true,
                scrollable: true
              }
            },
            [
              _c("my-project-color-preview-modal", {
                attrs: { productData: _vm.productData }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: {
                height: "500",
                name: "add-to-basket-modal",
                "data-html2canvas-ignore": "true",
                adaptive: true,
                scrollable: true
              }
            },
            [_c("my-project-add-to-basket-modal")],
            1
          ),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: {
                name: "add-to-cart-confirm-modal",
                height: "auto",
                "data-html2canvas-ignore": "true",
                adaptive: true
              }
            },
            [
              _c("pc-confirm-modal", {
                attrs: {
                  header:
                    _vm.$resourceString[
                      "myProject.add.to.basket.confirm.header"
                    ],
                  subheader:
                    _vm.$resourceString[
                      "myProject.add.to.basket.confirm.subheader"
                    ],
                  close: _vm.closeAddToBasketConfirm,
                  isMyProject: _vm.vtId,
                  hidePopup: false
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "vue-pc-inspiration-section-page" } },
            [
              _c("pc-inspiration-images-gallery", {
                attrs: { isMyproject: true }
              })
            ],
            1
          )
        ],
        2
      )
    : _c("div", { staticClass: "container text-center" }, [
        _c("p", {}, [
          _vm._v(_vm._s(_vm.$resourceString["common.NoDataAvailable.Msg"]))
        ])
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn dropdown-toggle-split p-0",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [
        _c("span", { staticClass: "sr-only" }),
        _vm._v(" "),
        _c("img", {
          staticStyle: { width: "5px" },
          attrs: {
            src:
              "https://szue2patcraftblobpstb01.blob.core.windows.net/media/patcraft/media/patcraftmedia/frontendicons/ellipsis-vertical-solid.svg",
            alt: ""
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", {
        staticClass:
          "d-flex flex-wrap text-muted  justify-content-end text-size-small"
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }